import React, {Component} from 'react';
import CommesseSelectTableRow from './CommesseSelectTableRow'
import PropTypes from 'prop-types';

class CommessaSelectListComplete extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.onCommessaSelect = this.onCommessaSelect.bind(this)
    }

    onCommessaSelect(commessa){
        this.props.onChange(commessa);
    }

    render() {

        let cardClassName = this.props.fluid ? "ui fluid card" : "ui card";
        return (<div className={cardClassName}>

            <div className="content">
                <div className="header">
                    {this.props.title}
                </div>
                <div style={{height:this.props.height, overflowX:"scroll"}}>
            <table className="ui fixed single line very basic table">
                <tbody>
                {this.props.commesseList.map((commessa) => (
                    <CommesseSelectTableRow
                        commessa={commessa}
                        key={commessa.idCommessa}
                        onCommessaSelect={this.onCommessaSelect}
                    />
                ))}
                </tbody>
            </table>
                </div>
        </div>
        </div>)
    }
}

CommessaSelectListComplete.PropTypes = {
    title: PropTypes.string.isRequired,
    height: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    fluid: PropTypes.bool.isRequired,
    compact: PropTypes.bool.isRequired,
    commesseList: PropTypes.array.isRequired,
}

CommessaSelectListComplete.defaultProps = {
    height: "400px",
    fluid: false,
    compact: false,
    title: 'Seleziona la commessa desiderata...'
};


CommessaSelectListComplete.contextTypes = {
    router: PropTypes.object
}

export default CommessaSelectListComplete;




/** WEBPACK FOOTER **
 ** ./src/components/commesse/CommessaSelectListComplete.js
 **/